import { SkeletonText } from '@carbon/react';
import style from './workspace-accordion.module.scss';

/**
 * Skeleton placeholder that matches the WorkspaceAccordion summary layout.
 * Shown while workspaces are loading.
 *
 * @return {JSX.Element} The skeleton accordion.
 */
export const WorkspaceAccordionSkeleton = (): JSX.Element => {
  return (
    <div className={style.workspace}>
      <div className={style.skeletonSummary}>
        <SkeletonText heading width="50%" />
        <SkeletonText width="40%" />
        <SkeletonText width="45%" />
      </div>
    </div>
  );
};
